<template>
  <section class="section player-info awaiting">
    <div class="loading-info-container">
      <img
        class="loading-icon"
        src="../assets/img/icons/spinner-solid.svg"
        alt="Loading icon"
      />
      <p>Czekam na wprowadzenie nicku...</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "PlayerNotFetched"
};
</script>
